import _ from 'lodash';

function EventContentCtrl($http, $rootScope, $scope, $state, $stateParams, $timeout, $interval, toastr, AppSettings, ChartGeneratorService, PlanService, EventAnalysisService, PlayerService, AppContextService, DashboardService) {
  'ngInject';

  const vm = this;
  vm.viewContentLoaded = false;

  vm.appContext = AppContextService.context;
  vm.menu = 'sa21c';
  vm.typeCode = $stateParams.type_code;

  var getGameInfo = function() {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: $stateParams.id,
    };
    PlanService.getGameInfo(data)
      .then(function (res) {
        vm.date = res.data.date;
      })
      .catch(function (error) {
        console.log('ERROR ' + error);
      });
  }
  var getTrainingInfo = function() {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      training_root_id: $stateParams.id,
    };

    PlanService.getTraining(data)
      .then(function (res) {
        vm.date = res.data.date;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
  };
  if (vm.typeCode === 'game') {
    getGameInfo();
  } else if (vm.typeCode === 'training') {
    getTrainingInfo();
  }

  vm.submenu = 'full-ground';

  // submenu 변경시 tracking 차트 다시 그리기
  $scope.$watch('vm.submenu', function (newVal, oldVal) {
    if (!vm.viewContentLoaded) {
      return;
    }

    $('.ground').hide();
    $('#design-' + newVal).show();

    $timeout(function () {
      drawTrackingChart(vm.submenu);
    }, 0);
  });

  /*
   * tracking 차트 시작
   */
  let trackingChartInstance = null;
  let trackingChartTimer = null;

  function drawTrackingChart(mode) {
    return;
    let ground;
    let groundWidth;
    let groundHeight;

    if (mode === 'full-ground') {   // 전체 경기장
      ground = $('#design-full-ground');
      groundWidth = ground.width();
      groundHeight = parseInt((groundWidth * AppSettings.location.fieldHeight) / AppSettings.location.fieldWidth, 10);  // 배경 이미지 비율에 맞게 높이 결정
    } else if (mode === 'half-ground') {  // 경기장 반
      ground = $('#design-half-ground');
      groundWidth = ground.width();
      groundHeight = parseInt((groundWidth * AppSettings.location.halfFieldHeight) / AppSettings.location.halfFieldWidth, 10);  // 배경 이미지 비율에 맞게 높이 결정
    } else if (mode === 'small-ground') { // 잔디밭
      ground = $('#design-small-ground');
      groundWidth = ground.width();
      groundHeight = parseInt((groundWidth * AppSettings.location.smallFieldHeight) / AppSettings.location.smallFieldWidth, 10);  // 배경 이미지 비율에 맞게 높이 결정
    }
    ground.height(groundHeight);

    // tracking 차트 그리기
    trackingChartInstance = ground.highcharts();
    if (trackingChartInstance) {
      trackingChartInstance.destroy();
    }

    let width = groundWidth;
    let height = groundHeight;

    let data = [{
      x: 50,
      y: 45,
      z: 10,
      name: '곽태휘'
    },
    {
      x: 26.5,
      y: 72.9,
      z: 10,
      name: '권순태'
    },
    {
      x: 85.8,
      y: 91.5,
      z: 10,
      name: '김진수'
    },
    {
      x: 50.4,
      y: 30.5,
      z: 10,
      name: '기성용'
    },
    {
      x: 30.3,
      y: 80.1,
      z: 10,
      name: '장현수'
    },
    {
      x: 75.4,
      y: 7.1,
      z: 10,
      name: '최철순'
    },
    {
      x: 74.2,
      y: 60.5,
      z: 10,
      name: '한국영'
    },
    {
      x: 33.5,
      y: 83.1,
      z: 10,
      name: '손흥민'
    },
    {
      x: 72,
      y: 23.2,
      z: 10,
      name: '이재성'
    },
    {
      x: 59.2,
      y: 47.6,
      z: 10,
      name: '지동원'
    },
    {
      x: 58.6,
      y: 30,
      z: 10,
      name: '황희찬'
    }
    ];

    Highcharts.chart('design-' + mode, {

      chart: {
        type: 'bubble',
        width: width,
        height: height,
        backgroundColor: 'transparent',
        margin: [0, 25, 0, 25]
      },

      credits: {
        enabled: false
      },

      legend: {
        enabled: false
      },

      title: {
        text: ''
      },

      tooltip: {
        enabled: false
      },

      xAxis: {
        gridLineWidth: 0,
        labels: {
          enabled: false
        },
        tickLength: 0
      },

      yAxis: {
        startOnTick: false,
        endOnTick: false,
        gridLineWidth: 0,
        title: {
          enabled: false
        },
        labels: {
          enabled: false
        }
      },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          marker: {
            fillOpacity: 0.7,
            lineColor: '#333',
            lineWidth: 1
          }
        },
        bubble: {
          maxSize: 40
        }
      },

      series: [{
        color: '#fdcc00',
        data: data
      }]
    });

    if (trackingChartTimer) {
      clearInterval(trackingChartTimer);
    }

    trackingChartTimer = setInterval(function () {
      let chart = ground.highcharts();

      _.forEach(data, function (item) {
        if (Math.random() > 0.5) {
          item.x = item.x + 1;
        } else {
          item.x = item.x - 1;
        }

        if (Math.random() > 0.5) {
          item.y = item.y + 1;
        } else {
          item.y = item.y - 1;
        }
      });

      _.forEach(chart.series[0].data, function (item, i) {
        item.update({
          x: data[i].x,
          y: data[i].y
        }, false, false);
      });

      chart.redraw();
    }, 800);
  }

  $scope.$on('$viewContentLoaded', function (event) {
    vm.viewContentLoaded = true;

  });

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });
  // tracking 차트 끝

  // 대시보드 조회 시작
  vm.dashboard = {};

  var data = {
    login_id: vm.appContext.user.login_id,
    show_user_type_id: 2
  };
  
  // 전체관리자가 선택한 team_id
  if ($stateParams.manager_admin_team_id) {
    data.team_id = $stateParams.manager_admin_team_id;
  }
  // 팬이 선택한 team_id
  else if ($stateParams.fan_team_id) {
    data.team_id = $stateParams.fan_team_id;
  }
  // 감독-선수 소속팀 관련 수정
  // 감독-선수가 선택한 team_id
  else if ($stateParams.coach_player_team_id) {
    data.team_id = $stateParams.coach_player_team_id;
  }
  else if ($stateParams.team_id) {
    data.team_id = $stateParams.team_id;
  }

  vm.dashboardItem = {
    videos: {
      '지도': [],
      '재활': []
    },
    contents: {
      '지도': [],
      '재활': []
    }
  };
  DashboardService.list(data)
    .then(function (res) {
      vm.dashboard = res.data;

      _.forEach(vm.dashboard.lists, item => {
        _.map(item.list[0].videos, video => {
          if (video.url.indexOf('?v=') > -1) {
            video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
          } else {
            video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
          }
        });
      });
      

      vm.dashboard = (_.find(res.data.lists, {
        type: $stateParams.type_name
      })).list[0];

      // subtitle 에 '지도-' 또는 '재활-' 이 있어야함
      _.forEach(vm.dashboard.videos, function(video) {
        if (video.subtitle.match('지도-')) {
          video.subtitle = video.subtitle.split('지도-')[1];
          vm.dashboardItem.videos['지도'].push(video);
        }
        if (video.subtitle.match('재활-')) {
          video.subtitle = video.subtitle.split('재활-')[1];
          vm.dashboardItem.videos['재활'].push(video);
        }
      });
      _.forEach(vm.dashboard.contents, function(content) {
        if (content.subtitle.match('지도-')) {
          content.subtitle = content.subtitle.split('지도-')[1];
          vm.dashboardItem.contents['지도'].push(content);
        }
        if (content.subtitle.match('재활-')) {
          content.subtitle = content.subtitle.split('재활-')[1];
          vm.dashboardItem.contents['재활'].push(content);
        }
      });
      // vm.someobj = res.data;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  // 대시보드 조회 끝

  // 지도자료 검색 기능
  vm.contentSearch = function() {
    DashboardService.list(data)
      .then(function (res) {
        vm.dashboard = res.data;

        _.forEach(vm.dashboard.lists, item => {
          _.map(item.list[0].videos, video => {
            if (video.url.indexOf('?v=') > -1) {
              video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
            } else {
              video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
            }
          });
        });
        

        vm.dashboard = (_.find(res.data.lists, {
          type: $stateParams.type_name
        })).list[0];

        // subtitle 에 '지도-' 또는 '재활-' 이 있어야함
        _.forEach(vm.dashboard.videos, function(video) {
          if (video.subtitle.match('지도-')) {
            video.subtitle = video.subtitle.split('지도-')[1];
            vm.dashboardItem.videos['지도'].push(video);
          }
          if (video.subtitle.match('재활-')) {
            video.subtitle = video.subtitle.split('재활-')[1];
            vm.dashboardItem.videos['재활'].push(video);
          }
        });
        _.forEach(vm.dashboard.contents, function(content) {
          if (content.subtitle.match('지도-')) {
            content.subtitle = content.subtitle.split('지도-')[1];
            vm.dashboardItem.contents['지도'].push(content);
          }
          if (content.subtitle.match('재활-')) {
            content.subtitle = content.subtitle.split('재활-')[1];
            vm.dashboardItem.contents['재활'].push(content);
          }
        });
        // vm.someobj = res.data;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
  };

  // 훈련 데이터 조회
  PlanService.getTrainingMeta()
    .then(function (res) {

      // 훈련장비
      vm.equipments = res.data.equipments;
      vm.equipment = vm.equipments[0];

      // 훈련목표
      vm.targets = res.data.targets;
      vm.target = vm.targets[0];

      // 훈련계획
      vm.plans = res.data.plans;
      vm.plan = vm.plans[0];
      
      // 훈련내용
      vm.movements = res.data.movements;
      vm.movement = vm.movements[0];

      // 준비정리
      vm.wcs = res.data.wcs;
      vm.wc = vm.wcs[0];

      // 코디훈련
      vm.coords = res.data.coords;
      vm.coord = vm.coords[0];

      // 코어훈련
      vm.weights = res.data.weights;
      vm.weight = vm.weights[0];

    })
    .catch(function (error) {
      console.log('ERROR ' + error);
    });

  vm.searchDataText = null;

  // 자료 검색 시작
  vm.recommendedVideos = [];
  vm.searchItemName = '';
  vm.isFirstSearch = true;
  var footballArr = ['football', 'football', 'football', 'soccer', 'soccer', 'futsal']; // 검색결과가 다양하게 나오게 하기 위한 처리, football, soccer 에 가중치를 줌

  vm.searchData = function () {
    if (!vm.searchDataText) {
      toastr.error('검색어를 입력해주십시오');
      return;
    }

    toastr.info('자료를 검색중입니다.', {
      timeOut: 500
    });
    var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' training ' + vm.searchDataText;
    var params = {
      q: q,
      part: 'snippet', 
      maxResults: 10
    };
    if (vm.searchItemName === vm.searchDataText) {  // 같은 훈련내용을 연속해서 입력하는 경우 다른 검색결과를 조회하기 위해 pageToken parameter 설정 예) 훈련내용 공격 입력 후 다시 공격 입력 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      params.pageToken = 'CAoQAA';
    }
    vm.searchItemName = _.clone(vm.searchDataText);
    
    PlanService.getVideoRecommend(params)
      .then(function(res) {
        $('#search-data-results').empty();
        var srchItems = res.items,
          videos = [];
        $.each(srchItems, function(index, item) {
          if  (item.id.kind === 'youtube#video') {
            videos.push({
              id: item.id.videoId,
              title: item.snippet.title,
              url: 'https://youtube.com/watch?v='  +  item.id.videoId
            });

            var vidThumburl =  item.snippet.thumbnails.default.url;                 
            var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
            var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"></div></div>';  

            if (vm.appContext.isMobile) {
              $('#search-data-results').append('<li class="play-video" data-id="' + item.id.videoId + '" style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px; float:left;">' + vidThumbimg + vidTitle + '</li>');
            } else {
              $('#search-data-results').append('<li class="play-video" data-id="' + item.id.videoId + '" style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px; float:left; width:33%;">' + vidThumbimg + vidTitle + '</li>');
            }
          }
        });

        vm.recommendedVideos = videos;

        vm.isFirstSearch = false;
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  $('body').off('click.selectVideo click.playVideo').on('click.playVideo', '.play-video', function(e) {
    e.preventDefault();

    var li = $(this);

    document.getElementById('game_video').style.display = 'block';

    $scope.$apply(function () {
      vm.selectedVideo = _.find(vm.recommendedVideos, {
        id: li.data('id')
      });
    });
  });
  // 자료 검색 끝

}

export default {
  name: 'EventContentCtrl',
  fn: EventContentCtrl
};
